export interface ExportColumn<T> {
  header: string;
  accessor: keyof T | ((row: T) => string | number);
}

function escapeCsvValue(value: string): string {
  if (/[",\r\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }

  return value;
}

function getCellValue<T>(row: T, accessor: ExportColumn<T>['accessor']): string {
  const rawValue =
    typeof accessor === 'function' ? accessor(row) : (row[accessor] as string | number | null | undefined);

  if (rawValue === null || rawValue === undefined) return '';
  return String(rawValue);
}

export function exportToCsv<T>(data: T[], columns: ExportColumn<T>[], filename: string): void {
  if (typeof window === 'undefined' || typeof document === 'undefined' || data.length === 0) return;

  const headerRow = columns.map((column) => escapeCsvValue(column.header)).join(',');
  const rows = data.map((row) =>
    columns
      .map((column) => escapeCsvValue(getCellValue(row, column.accessor)))
      .join(','),
  );

  const csv = `\uFEFF${[headerRow, ...rows].join('\r\n')}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
